import React from 'react'

import MESSAGE from '../../business-const/Message/Message'

import {
    ListRadioGroup,
} from '../../business-components/RadioGroup/RadioGroup'

import sexoList from '../List/sexoList'

export const SexoRadioGroup = props => {
    return (
        <ListRadioGroup
            list={sexoList(false)}
            {...props}
        />
    )
}

export const SexoRadioGroupRequired = props => {
    return (
        <>
            <SexoRadioGroup
                {...props}
            />
            {props.value ? '' : MESSAGE().campoObrigatorioRadioGroup}
        </>
    )
}